export const MUX_ENV_KEY = '9agg7pld771p850mf45msngp3';
